import { useState, useEffect } from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import { getIsDesktop } from '../../../utils/Utils';
import BaseDesktopDialog from '../../../custom_views/BaseDesktopDialog';

function WriteToDevelopersDialog(props) {
    const isDesktop = getIsDesktop()
    const write = () => {
        props.setShow(false)
        window.open('mailto:sozvon-pro@yandex.ru')
    }
    const getInnerHtml = () => {
        return(
            <div className="call_info_container">
                <div className="write_to_dev_title">Написать разработчикам</div>
                <div style={{maxWidth : '360px'}} className="call_edit_desc">По возникающим вопросам и предложениям сотрудничества пишите, пожалуйста, на адрес: sozvon-pro@yandex.ru</div>
                <div style={{marginTop : '36px'}} className="flex">
                    <div style={{margin : '0 24px'}} onClick={write} className="call_price_continue hover">Написать разработчикам</div>
                </div>
                <div style={{marginTop : '0', justifyContent : 'center'}} className="flex">
                    <div style={{margin : '16px 24px 0 24px', textAlign : 'center'}} onClick={() => props.setShow(false)} className="cancel_call_info hover">Отмена</div>
                </div>
            </div>
        )
    }
    if (isDesktop){
        return(<BaseDesktopDialog isShow={props.isShow} setShow={props.setShow} getInnerHtml={getInnerHtml}/>)
    } else {
        return (
            <BottomSheet style={{zIndex : 9999}} onDismiss={() => props.setShow(false)} open={props.isShow}>
                {getInnerHtml()}
            </BottomSheet>
        )
    }
    
}

export default WriteToDevelopersDialog;
